@for (scope of scopes(); track scope; let isLast = $last) {
  <span
    class="rounded-full px-2 py-1 text-xs"
    [ngClass]="{
      'bg-accent-500 text-white': scope === highlightScope(),
      'bg-slate-100 text-slate-500': scope !== highlightScope()
    }"
  >
    {{ scope | splitKebab | titlecase }}
  </span>
  @if (!isLast) {
    &nbsp;
  }
}
